import React from "react";
import style from "../../styles/instructionview";
import DocumentView from "./DocumentView";
import InstructionDetails from "./InstructionDetails";
import InstructionPhoto from "./InstructionPhoto";
import InstructionVideo from "./InstructionVideo";
import YouTubeVideo from "./YouTubeVideo";
import IconDelete from "material-ui/svg-icons/action/delete";
import IconEdit from "material-ui/svg-icons/image/edit";
import IconArchive from "material-ui/svg-icons/file/folder";
import IconActivate from "material-ui/svg-icons/av/play-arrow";
import colors, { colorsV2 } from "../../styles/colors";
import WistiaAsyncVideo from "./WistiaAsyncVideo";

import PlayIcon from "@material-ui/icons/PlayCircleFilled";
import ImageIcon from "@material-ui/icons/Image";
import { Tooltip } from "@material-ui/core";

export default (props) => {
  const removeDetails = (iframeHtml) => {
    const url = iframeHtml.substring(
      iframeHtml.indexOf("src=") + 5,
      iframeHtml.indexOf("width") - 2
    );
    return (
      <iframe
        title="Physio PT Video"
        src={url}
        style={{ width: 500, height: 500 }}
        frameborder="0"
        allowfullscreen
      ></iframe>
    );
  };

  const headerStyle = {
    fontSize: 16,
    color:
      props.whiteLabelSettings && props.whiteLabelSettings.isWhiteLabel
        ? props.whiteLabelSettings.primaryColor
        : colors.primary,
    margin: 0,
    padding: 0,
  };
  const uderLineHeaderStyle = {
    fontSize: 16,
    color:
      props.whiteLabelSettings && props.whiteLabelSettings.isWhiteLabel
        ? props.whiteLabelSettings.primaryColor
        : colors.primary,
    textDecoration: "underline",
    margin: 2,
    padding: 0,
  };

  const hasVideo = () => {
    return (
      props.videoUrl !== undefined ||
      (props.youtubeVideo && props.youtubeVideo.url !== "") ||
      props.physioVideo !== undefined ||
      (props.wistiaVideo && props.wistiaVideo.url !== "")
    );
  };

  const hasImage = () => {
    return props.imageUrl != null || props.physioImage != null;
  };

  return (
    <div style={style.container}>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
        }}
      >
        <div style={{ display: "flex", flexDirection: "column" }}>
          {props.groupName && props.groupName.trim().length > 0 && (
            <h1 style={uderLineHeaderStyle}>{props.groupName}</h1>
          )}
          <h1 style={headerStyle}>
            {props.archived && "*Archived*  "}
            {props.categoryName}
          </h1>
        </div>
        <div style={{ display: "flex", flexDirection: "row" }}>
          <div
            style={{ display: "flex", flexDirection: "row", marginRight: 100 }}
          >
            {hasImage() && (
              <Tooltip id="archiveButton" title="Instruction Contains An Image">
                <ImageIcon
                  style={{
                    fontSize: 24,
                    marginRight: 5,
                    color: colorsV2.lightningYellow,
                  }}
                />
              </Tooltip>
            )}
            {hasVideo() && (
              <Tooltip id="archiveButton" title="Instruction Contains A Video">
                <PlayIcon
                  style={{ fontSize: 24, color: colorsV2.lightningYellow }}
                />
              </Tooltip>
            )}
          </div>
          {props.onDeleteClick && props.onEditClick && (
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "flex-end",
              }}
            >
              <Tooltip id="deleteButton" title="Delete">
                <IconDelete
                  onClick={props.onDeleteClick}
                  style={{
                    cursor: "pointer",
                    color: "black",
                  }}
                  areaLabel="Remove"
                />
              </Tooltip>
              <Tooltip id="editButton" title="Edit">
                <IconEdit
                  onClick={props.onEditClick}
                  style={{
                    marginRight: 5,
                    cursor: "pointer",
                    color: "black",
                  }}
                  areaLabel="Edit"
                />
              </Tooltip>
              <Tooltip id="archiveButton" title="Archive">
                <IconArchive
                  onClick={props.onArchiveActivate}
                  style={{
                    marginRight: 5,
                    cursor: "pointer",
                    color: "black",
                  }}
                />
              </Tooltip>
            </div>
          )}
        </div>
      </div>
      {/*
      <div style={style.mediaBlock}>
        {props.videoUrl && (
          <InstructionVideo
            url={props.videoUrl}
            prevUrl={props.videoPreviewUrl}
            style={{
              maxHeight: 250,
              maxWidth: 250,
              objectFit: "cover",
              borderRadius: 10,
              overFlow: "hidden",
            }}
            instructionId={props.categoryId}
            userId={props.userId}
          />
        )}
      
        {props.physioVideo && removeDetails(props.physioVideo)}
        {props.youtubeVideo && props.youtubeVideo.url && (
          <YouTubeVideo
            embedId={props.youtubeVideo.id}
            instructionId={props.categoryId}
            userId={props.userId}
          />
        )}
        {props.wistiaVideo && props.wistiaVideo.url && (
          <WistiaAsyncVideo wistiaVideo={props.wistiaVideo} />
        )}
        {props.physioImage && (
          <InstructionPhoto
            url={props.physioImage}
            style={{
              maxHeight: 250,
              maxWidth: 250,
              objectFit: "cover",
              borderRadius: 10,
              overFlow: "hidden",
            }}
          />
        )}
        {props.imageUrl && (
          <InstructionPhoto
            url={props.imageUrl}
            style={{
              maxHeight: 250,
              maxWidth: 250,
              objectFit: "cover",
              borderRadius: 10,
              overFlow: "hidden",
            }}
          />
        )}
      </div>
          */}
      <div
        style={{ fontSize: 12, margin: 0, padding: 0 }}
        dangerouslySetInnerHTML={{
          __html: props.categoryDescWithFormat
            ? props.categoryDescWithFormat
            : props.categoryDesc,
        }}
      />
      <DocumentView documents={props.documents} />
      <InstructionDetails {...props} />
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/common/InstructionView.js